import { Common } from "../Components/Canvas";
import Utility from "../js/utility";

export default class AddAsset {
  sticker = () => {
    let chosenImageContainer = document.querySelector(".chosenImageContainer");
    let stickersMenu = document.querySelector(".stickers");

    stickersMenu.addEventListener("click", function (ev) {
      let target = ev.target;
      if (target.nodeName !== "IMG") return;

      Utility.hideMenus();

      let rect = document.querySelector(".rect");
      rect.style.backgroundImage = `url("${target.src}")`;

      chosenImageContainer.classList.add("showImageContainer");
      Common.newImage.setAttribute("crossOrigin", "");
      Common.newImage.src = target.src + "?" + new Date().getTime();
    });
  };

  photo = (draw_image) => {
    let addImage = document.querySelector(".addImage");
    let cancelImage = document.querySelector(".cancelImage");

    function cancel_image() {
      Utility.revealMenusInstant();

      let chosenImgContainer = document.querySelector(".chosenImageContainer");
      let choose_image_buttons = document.querySelector(".chooseImageButtons");

      chosenImgContainer.classList.remove("showImageContainer");
      choose_image_buttons.style.left = "";
      choose_image_buttons.style.top = "";
    }

    addImage.addEventListener("click", draw_image);
    cancelImage.addEventListener("click", cancel_image);
  };
}
